<script>
export default {
  name: "pfennigparadeVue",
  data() {
    return {
      geojsonFeature: {
        type: "FeatureCollection",
        name: "pfennigparade",
        crs: {
          type: "name",
          properties: { name: "urn:ogc:def:crs:OGC:1.3:CRS84" },
        },
        features: [
          {
            type: "Feature",
            properties: {
              Id: 0,
              name: "Pfennigparade",
              address: "Barlachstraße 24-36",
              website: "www.pfennigparade.de/",
            },
            geometry: {
              type: "Point",
              coordinates: [11.576584406886893, 48.176704528962418, 0.0],
            },
          },
        ],
      },
    };
  },
};
</script>
